import React, { useEffect, useState } from 'react';
const CHECKOUT_WITH_BONUS_URL = 'https://betterdailyguides.com/cart/51926505685294:1';
const CHECKOUT_WITHOUT_BONUS_URL = 'https://betterdailyguides.com/cart/51925795668270:1';
const CHECKOUT_DISCOUNT_BONUS_URL = 'https://betterdailyguides.com/cart/51926784508206:1';
interface UpsellPopupProps {
  isOpen: boolean;
  onClose: () => void;
}
function CountdownTimer() {
  const [seconds, setSeconds] = useState(300);
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return <div className="flex items-center justify-center gap-2 mb-4" data-id="element-298">
      <div className="bg-[#3D2B1F] text-white rounded-lg px-3 py-1.5 text-center min-w-[48px]" data-id="element-299">
        <span className="text-xl font-bold font-mono" data-id="element-300">
          {String(mins).padStart(2, '0')}
        </span>
        <div className="text-[9px] uppercase tracking-wider opacity-70" data-id="element-301">
          min
        </div>
      </div>
      <span className="text-[#3D2B1F] text-xl font-bold" data-id="element-302">:</span>
      <div className="bg-[#3D2B1F] text-white rounded-lg px-3 py-1.5 text-center min-w-[48px]" data-id="element-303">
        <span className="text-xl font-bold font-mono" data-id="element-304">
          {String(secs).padStart(2, '0')}
        </span>
        <div className="text-[9px] uppercase tracking-wider opacity-70" data-id="element-305">
          sec
        </div>
      </div>
    </div>;
}
export function UpsellPopup({
  isOpen,
  onClose
}: UpsellPopupProps) {
  const [step, setStep] = useState<1 | 2>(1);
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      setStep(1);
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  const handleAcceptFull = () => {
    window.location.href = CHECKOUT_WITH_BONUS_URL;
  };
  const handleDeclineToDiscount = () => {
    setStep(2);
  };
  const handleAcceptDiscount = () => {
    window.location.href = CHECKOUT_DISCOUNT_BONUS_URL;
  };
  const handleDeclineFinal = () => {
    window.location.href = CHECKOUT_WITHOUT_BONUS_URL;
  };
  if (step === 2) {
    return <div className="fixed inset-0 z-[10001] bg-black/70 flex items-center justify-center p-4" data-id="element-306">
        <div className="bg-[#FAF7F2] rounded-2xl max-w-[400px] w-full relative overflow-hidden shadow-2xl" style={{
        animation: 'popupEnter 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)',
        boxShadow: '0 0 0 3px rgba(231, 76, 60, 0.3), 0 25px 60px rgba(0,0,0,0.3)'
      }} onClick={e => e.stopPropagation()} data-id="element-307">
          {/* Urgent red top bar */}
          <div className="bg-[#e74c3c] py-2 px-4 text-center" data-id="element-308">
            <span className="text-white text-[11px] font-bold tracking-widest uppercase font-sans" data-id="element-309">
              🚨 LAST CHANCE — DON'T MISS THIS 🚨
            </span>
          </div>

          <div className="p-6 text-center" data-id="element-310">
            <div className="text-4xl mb-3" data-id="element-311">🔥</div>

            <h2 className="text-xl font-bold text-[#3D2B1F] leading-tight mb-1" data-id="element-312">
              Wait! <span className="text-[#e74c3c]" data-id="element-313">Exclusive 30% OFF</span>
            </h2>

            <p className="text-sm text-[#6B4C3B] font-sans mb-3" data-id="element-314">
              Since you're leaving, here's a <strong data-id="element-315">one-time discount</strong>{' '}
              on the Peace of Mind Planner.
            </p>

            <CountdownTimer data-id="element-316" />

            {/* Price */}
            <div className="bg-white rounded-xl p-4 border-2 border-[#e74c3c]/20 mb-4 relative" data-id="element-317">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#e74c3c] text-white text-[10px] font-bold px-3 py-0.5 rounded-full uppercase tracking-wider" data-id="element-318">
                Final Offer
              </div>
              <div className="text-xs text-gray-400 line-through font-sans" data-id="element-319">
                $4.99
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-320">
                <span className="text-3xl font-bold text-[#3D2B1F]" data-id="element-321">$3.49</span>
                <span className="bg-[#e74c3c] text-white text-[10px] font-bold px-2 py-0.5 rounded-full" data-id="element-322">
                  SAVE 30%
                </span>
              </div>
            </div>

            <button onClick={handleAcceptDiscount} className="w-full bg-[#e74c3c] hover:bg-[#c0392b] text-white text-base font-bold py-3.5 px-5 rounded-full shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5 font-sans uppercase cursor-pointer border-none animate-cta-pulse" data-id="element-323">
              🎁 YES! GIVE ME 30% OFF →
            </button>

            <button onClick={handleDeclineFinal} className="mt-3 bg-transparent border-none text-xs text-gray-400 font-sans cursor-pointer hover:text-gray-600 transition-colors underline underline-offset-2" data-id="element-324">
              No thanks, continue without the bonus →
            </button>

            <div className="flex justify-center gap-3 flex-wrap mt-4 text-[10px] text-gray-400 font-sans" data-id="element-325">
              <span data-id="element-326">🔒 Secure</span>
              <span data-id="element-327">📥 Instant Access</span>
              <span data-id="element-328">↩️ 30-Day Guarantee</span>
            </div>
          </div>
        </div>
      </div>;
  }
  return <div className="fixed inset-0 z-[10001] bg-black/70 flex items-center justify-center p-4" data-id="element-329">
      <div className="bg-[#FAF7F2] rounded-2xl max-w-[420px] w-full relative overflow-hidden shadow-2xl" style={{
      animation: 'popupEnter 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)',
      boxShadow: '0 0 0 3px rgba(201, 169, 110, 0.3), 0 25px 60px rgba(0,0,0,0.3)'
    }} onClick={e => e.stopPropagation()} data-id="element-330">
        {/* Gold top bar */}
        <div className="bg-gradient-to-r from-[#C9A96E] via-[#B76E79] to-[#C9A96E] py-2 px-4 text-center" data-id="element-331">
          <span className="text-white text-[11px] font-bold tracking-widest uppercase font-sans" data-id="element-332">
            ⚡ EXCLUSIVE ONE-TIME OFFER ⚡
          </span>
        </div>

        <div className="p-6 text-center" data-id="element-333">
          <div className="text-4xl mb-3" data-id="element-334">📋✨</div>

          <h2 className="text-xl font-bold text-[#3D2B1F] leading-tight mb-1" data-id="element-335">
            Wait! Unlock <span className="text-[#B76E79]" data-id="element-336">Bonus #5</span>
          </h2>

          <h3 className="text-lg text-[#C9A96E] font-bold mb-3 italic" data-id="element-337">
            Peace of Mind Planner
          </h3>

          <p className="text-sm text-[#6B4C3B] font-sans leading-relaxed mb-4 max-w-[360px] mx-auto" data-id="element-338">
            The ultimate week-by-week planner that organizes{' '}
            <strong className="text-[#3D2B1F]" data-id="element-339">
              sleep, feeding, milestones & stimulation
            </strong>{' '}
            into one simple system.
          </p>

          <div className="flex flex-col gap-1.5 mb-4 text-left max-w-[340px] mx-auto" data-id="element-340">
            {['52-week structured planner (full first year)', 'Daily sleep & feeding tracker built-in', 'Milestone checkpoints included', 'Pairs perfectly with B.A.B.Y. 365'].map((item, idx) => <div key={idx} className="flex items-center gap-2" data-id="element-341">
                <span className="text-green-500 text-xs font-bold" data-id="element-342">✓</span>
                <span className="text-xs text-[#3D2B1F] font-sans" data-id="element-343">{item}</span>
              </div>)}
          </div>

          {/* Price box */}
          <div className="bg-white rounded-xl p-4 border-2 border-[#C9A96E]/25 mb-4 relative" data-id="element-344">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#B76E79] text-white text-[10px] font-bold px-3 py-0.5 rounded-full uppercase tracking-wider" data-id="element-345">
              Today Only
            </div>
            <div className="text-xs text-gray-400 line-through font-sans" data-id="element-346">
              Regular: $29.99
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-347">
              <span className="text-3xl font-bold text-[#3D2B1F]" data-id="element-348">$4.99</span>
              <span className="bg-red-50 text-red-600 text-[10px] font-bold px-2 py-0.5 rounded-full" data-id="element-349">
                83% OFF
              </span>
            </div>
            <p className="text-[10px] text-[#B76E79] font-sans font-semibold mt-1" data-id="element-350">
              🔥 This offer will NOT be shown again
            </p>
          </div>

          <CountdownTimer data-id="element-351" />

          {/* Accept button */}
          <button onClick={handleAcceptFull} className="w-full bg-gradient-to-r from-[#B76E79] to-[#8B4A52] text-white text-base font-bold py-3.5 px-5 rounded-full shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5 font-sans uppercase cursor-pointer border-none animate-cta-pulse" data-id="element-352">
            🎁 YES! ADD IT FOR JUST $4.99 →
          </button>

          <p className="text-[10px] text-[#6B4C3B] font-sans mt-2 mb-3" data-id="element-353">
            Total: <strong data-id="element-354">$12.97 + $4.99 = $17.96</strong> for the complete
            system
          </p>

          {/* Decline banner */}
          <button onClick={handleDeclineToDiscount} className="w-full bg-gray-100 border border-gray-200 text-[#6B4C3B] text-xs font-medium py-2.5 px-4 rounded-full cursor-pointer hover:bg-gray-200 transition-all font-sans" data-id="element-355">
            No, continue without the bonus →
          </button>

          <div className="flex justify-center gap-3 flex-wrap mt-4 text-[10px] text-gray-400 font-sans" data-id="element-356">
            <span data-id="element-357">🔒 Secure Payment</span>
            <span data-id="element-358">📥 Instant Access</span>
            <span data-id="element-359">↩️ 30-Day Guarantee</span>
          </div>
        </div>
      </div>
    </div>;
}